import { Dispatch, SetStateAction } from "react";
import { InvoiceApi } from "../../../../../../../services/Api/Organization/types";
import { ExportInvoiceModalMode } from "../utils";
import { printInvoicePdf } from "./exportInvoice";

export const exportInvoiceToPDFHandler = async (
	invoice: InvoiceApi,
	setShowExportPdfInvoiceModal: Dispatch<SetStateAction<ExportInvoiceModalMode>>,
	mode: ExportInvoiceModalMode.EXPORT_TO_PDF | ExportInvoiceModalMode.PRINT
) => {
	if (mode === ExportInvoiceModalMode.PRINT) {
		await printInvoicePdf(invoice);
	} else {
		setShowExportPdfInvoiceModal(mode);
	}
};
